import MenuSheet from './components/MenuSheet';
import menuItems from './config';
import Overlay from '../../../Overlay';
import useMenu from '../../../../hooks/useMenu';

type MenuProps = {
  numPlayers: number;
};

export default function Menu({ numPlayers }: MenuProps) {
  const { isOpen, setClosed } = useMenu();

  return (
    <>
      <Overlay isOpen={isOpen} onClick={setClosed} className="z-10" />
      <MenuSheet
        isOpen={isOpen}
        onClose={setClosed}
        className="z-20"
        items={menuItems}
        numPlayers={numPlayers}
      />
    </>
  );
}
